export const isModalShownSelector = state => state.modal.isModalShown;
export const openedContactSelector = state => state.modal.openedContact;
